export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a
            className="navbar-brand page-scroll"
            href="#page-top"
          >
            <img src='img/flor-paz.jpeg' alt='Flor Paz' style={{ height: '70px', width: '120px'}}></img>
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#header" className="page-scroll">
                INICIO
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                SOBRE MI
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll">
                PORFOLIO
              </a>
            </li>
            <li>
              <a href="#gallery" className="page-scroll">
                CAPACITACIONES
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
                TESTIMONIOS
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                CONTACTO
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
